export default "__VITE_ASSET__svx2rFTg__"